export default __webpack_public_path__ + "static/media/George Latimer.932ed34f.jpg";